import React from 'react';
import '../../styles/transport.css'; // Import Hero specific CSS
import '../../styles/Fonts.css'; // Import Hero specific CSS
import 'bootstrap/dist/css/bootstrap.min.css';
import '@fortawesome/fontawesome-free/css/all.min.css'; // Import Font Awesome

import serviceImage2 from '../../assets/newsealand2.webp'; // Add your first service image
import serviceImage1 from '../../assets/newsealand.webp'; // Add your second service image

const BrokeragetServices = () => {
  return (
    <>
      {/* Services Section */}
      <section id="about-sealand" className="py-5 transport-section">
      <div className="container">
        <div className="row py-5 main-service">
          {/* Left Text Section */}
          <div className="col-lg-6 col-sm-12 d-flex align-items-center text-center text-lg-start desc-container">
            <div className="mb-5 container-services">
              <button disabled className="custom-button mb-4 poppins-bold text-black">WHAT WE PROVIDE</button>
              <h1 className='poppins-bold text-dark fs-1'>Our Services</h1>
              <p className='poppins-regular transport-desc text-justify text-dark'>
              Our sea-land shuttle services provide seamless, multimodal transport solutions, combining sea and land routes for efficient deliveries. We coordinate every step, ensuring your cargo moves smoothly from port to final destination with minimal delays. Whether you're shipping locally or regionally, our integrated network and reliable partners guarantee timely and secure transport. With flexible scheduling, real-time tracking, and customs support, we streamline the entire process. Let us handle the logistics,
              so your business can benefit from faster, more efficient sea-land shipping solutions.              </p>
            </div>
          </div>

          {/* Right Stats Section */}
          <div className="col-lg-6 col-md-12 position-relative">
            <div className="overlap-container">
              <img src={serviceImage1} alt="Sea-land transport operation" className="img-fluid overlap-img1" />
              <img src={serviceImage2} alt="Multimodal shipping solution" className="img-fluid overlap-img2" />
            </div>
          </div>
        </div>
      </div>
    </section>

      {/* Include te other sections */}
      
    </>
  );
};

export default BrokeragetServices;
